<template>
	<div class="task-color" @click="onClickColor">
		<div class="task-color__itself --bg-accent" :class="item.color"></div>
	</div>
</template>

<script>
import base from "@/mixins/base";

export default {
	name: "task-color",
	mixins: [base],
	props: {
		item: {
			type: Object,
		},
		/** Если true - вместо task/update только эмитит change(css), для черновика новой задачи. */
		local: {
			type: Boolean,
			default: false
		},
	},
	methods: {
		onClickColor(event) {
			this.dispatch("ui/colorSelector", {
				event,
			}).then(res => {
				if (this.local) {
					this.$emit("change", res?.css || null);
					return;
				}
				this.do("task/update", {
					taskId: this.item.id,
					params: {
						color: res?.css || null // res can be null!
					}
				});
			});
		},
	},
}
</script>

<style lang="scss">
.task-color {
	z-index: 2;
	position: absolute;
	left: 0;
	top: 0;
	width: 12px;
	height: 100%;
	cursor: pointer;
	@include transition();

	&:hover {
		background: map-get($blue, "lighten-4");

		.task-color__itself {
			width: 100%;
		}
	}

	&__itself {
		width: 4px;
		height: 100%;
		@include transition();
	}
}
</style>
